import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { CLPUser, UserResponse } from '../../../models/clpuser.model';
import { eFeatures, eUserRole } from '../../../models/enum.model';
import { SimpleResponse } from '../../../models/genericResponse.model';
import { RoleFeaturePermissions } from '../../../models/roleContainer.model';
import { TagsFields, TagsMgmt } from '../../../models/tag-settings.model';
import { GridColumnsConfigurationService } from '../../../services/gridColumnsConfiguration.service';
import { NotificationService } from '../../../services/notification.service';
import { GridConfigurationService } from '../../../services/shared/gridConfiguration.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { SignupService } from '../../../services/signup.service';
import { TagSettingService } from '../../../services/tag-setting.service';
import { process } from '@progress/kendo-data-query';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { GlobalService } from '../../../services/global.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-tag-setting',
    templateUrl: './tag-setting.component.html',
    styleUrls: ['./tag-setting.component.css'],
    providers: [GridConfigurationService]
})
export class TagSettingComponent implements OnInit {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    tagSettingsDataSource: MatTableDataSource<any>;
    tagSettingsDataDisplayColumns: string[] = [];
    user: CLPUser;
    private editedRowIndex: number = -1;
    showSpinner: boolean = false;
    public tagSettingsData: any;
    public initTagSettingsData: any;
    tagSettingsResponse: TagsMgmt[];
    arrTagSettings: any[] = [{ value: 2, name: "Contacts" }, { value: 4, name: "Companies" }, { value: 3, name: "Leads" }];

    hiddenColumns: string[] = [];
    arrSortingColumn: any[] = [];
    userResponse: UserResponse;
    roleFeaturePermissions: RoleFeaturePermissions;
    TagsFields: TagsFields;
    private encryptedUser: string = '';
    ownerType: number = 0;
    public formGroup: FormGroup;
    currentTagName: string = '';
    currentContactNo: number = 0;
    currentTagID: number = 0;
    @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;
    mobileColumnNames: string[];
    columns: { field: string; title: string; width: string; }[];
    reorderColumnName: string;
    columnWidth: string;
    arrColumnWidth: string[];
    constructor(public _gridCnfgService: GridConfigurationService, public _localService: LocalService, private _utilityService: UtilityService, private _router: Router, private _notifyService: NotificationService, public _signupService: SignupService,
        private _tagsettingsrvc: TagSettingService, private _globalService: GlobalService, public _gridColumnsConfigurationService: GridColumnsConfigurationService) {
        this._localService.isMenu = true;
    }

    ngOnInit(): void {
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(() => {
                    if (this.user) {
                        this.tagGetListByCLPCompanyWithCount(2);
                    }
                    else
                        this._router.navigate(['/login']);
                });
            }
            else
                this._router.navigate(['/login']);
        });
    }

    //getGridConfiguration() {
    //    this._gridCnfgService.columns = this.columns;
    //    this._gridCnfgService.reorderColumnName = this.reorderColumnName;
    //    this._gridCnfgService.columnWidth = this.columnWidth;
    //    this._gridCnfgService.arrColumnWidth = this.arrColumnWidth;
    //    this._gridCnfgService.getGridColumnsConfiguration(this.user.cLPUserID, 'tag_setting_grid').subscribe((value) => this._gridCnfgService.createGetGridColumnsConfiguration('tag_setting_grid').subscribe((value) => { }));
    //}

    //resetGridSetting() {
    //    this._gridCnfgService.deleteColumnsConfiguration(this.user.cLPUserID, 'tag_setting_grid').subscribe((value) => this.getGridConfiguration());
    //}

    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.TagSettings)
            .then(async (result: UserResponse) => {
                if (result) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    this.userResponse = UtilityService.clone(result);
                    if (this.userResponse) {
                        if (this.userResponse?.user) {
                            this.user = this.userResponse.user;
                            this._gridCnfgService.user = this.user;
                            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("tagSetting.authenticateR", err.message, null, 'Features ' + eFeatures.None);
                this._utilityService.handleErrorResponse(err);
            });
    }

    private closeEditor(grid, rowIndex = this.editedRowIndex) {
        this.editedRowIndex = -1;
        this.formGroup = undefined;
    }

    public editHandler(dataItem, rowIndex) {
        this.editedRowIndex = rowIndex;
    }

    public cancelHandler( rowIndex ) {
        this.formGroup = null;
        this.editedRowIndex = -1;
    }

    public saveHandler(dataItem, rowIndex): void {
        this.showSpinner = true;
        let tagField: TagsFields = <TagsFields>{};
        tagField.cLPCompanyID = this.user.cLPCompanyID
        tagField.tag = dataItem.tag
        tagField.tagID = dataItem.tagID
        tagField.ownerType = this.ownerType
        this._tagsettingsrvc.tagUpdate(this.encryptedUser, tagField)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    this.tagGetListByCLPCompanyWithCount(this.ownerType)
                    this._notifyService.showSuccess(response.messageString ? response.messageString : "Tag Setting updated Successfully.", "", 3000);
                    this.showSpinner = false;
                    this.editedRowIndex = -1;
                }
                else
                    this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("tag-setting.saveHandler", err.message, null, 'tagField ' + tagField);
                this._utilityService.handleErrorResponse(err);
            });
    }

    public removeHandler(dataItem ): void {
        if (dataItem != null)
            this.currentTagID = dataItem.tagID;
        this.currentTagName = dataItem.tag;
        this.currentContactNo = dataItem.contact;
    }

    deleteUser() {
        this.showSpinner = true;
        this._tagsettingsrvc.tagDelete(this.encryptedUser, this.currentTagID)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    this.tagGetListByCLPCompanyWithCount(this.ownerType)
                    this._notifyService.showSuccess('Tag Setting deleted successfully', "", 3000);
                    this.showSpinner = false;
                }
                else
                    this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("tag-setting.deleteUser", err.message, null, 'currentTagID ' + this.currentTagID);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async tagGetListByCLPCompanyWithCount(ownerType) {
        this.showSpinner = true;
        await this._tagsettingsrvc.tagGetListByCLPCompanyWithCount(this.encryptedUser, this.user.cLPCompanyID, ownerType)
            .then(async (result: TagsMgmt[]) => {
                if (result) {
                    this.tagSettingsResponse = UtilityService.clone(result);
                    this.tagSettingsData = this.tagSettingsResponse;
                    this.initTagSettingsData = this.tagSettingsResponse;
                    this.ownerType = ownerType;
                    await this.arrangeGridAccToOwner(this.ownerType)
                    this.setGrid(this.tagSettingsData);
                    //if (!isNullOrUndefined(this._gridCnfgService)) {
                    //    this._gridCnfgService.iterateConfigGrid(this.tagSettingsResponse, "tag_setting_grid");
                    //    this.mobileColumnNames = this._gridCnfgService.getResponsiveGridColums('tag_setting_grid');
                    //}
                    this.showSpinner = false;
                }
                else
                    this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("tag-setting.tagGetListByCLPCompanyWithCount", err.message, null, 'cLPCompanyID ' + this.user.cLPCompanyID + "," + "ownerType " + ownerType);
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }

    onTagSettingFilter(inputValue: string): void {
        //this.tagSettingsData = process(this.initTagSettingsData, {
        //    filter: {
        //        logic: "or",
        //        filters: [
        //            { field: 'tag', operator: 'contains', value: inputValue },
        //            { field: 'contact', operator: 'contains', value: inputValue }
        //        ],
        //    }
        //}).data;
        //this.dataBinding.skip = 0;

        inputValue = inputValue.trim().toLowerCase();

        if (this.tagSettingsDataSource) {
            this.tagSettingsDataSource.filterPredicate = (data: any, filter: string) => {
                return Object.keys(data).some((key) => {
                    return data[key]?.toString().toLowerCase().includes(filter);
                });
            };

            this.tagSettingsDataSource.filter = inputValue;
        }
    }

    arrangeGridAccToOwner(ownerType) {
        let owner = +ownerType
        switch (owner) {
            case 2:
                this.columns = [{ field: '$', title: '', width: '40' }, { field: 'tag', title: 'Tag', width: '800' }, { field: 'contact', title: 'Contact', width: '250' }];
                this.reorderColumnName = 'tag,contact';
                this.columnWidth = 'tag:800,contact:250';
                this.arrColumnWidth = ['tag:800,contact:250'];
                break;

            case 3:
                this.columns = [{ field: '$', title: '', width: '40' }, { field: 'tag', title: 'Tag', width: '800' }, { field: 'contact', title: 'Lead', width: '250' }];
                this.reorderColumnName = 'tag,contact';
                this.columnWidth = 'tag:800,contact:250';
                this.arrColumnWidth = ['tag:800,contact:250'];
                break
            case 4:
                this.columns = [{ field: '$', title: '', width: '40' }, { field: 'tag', title: 'Tag', width: '800' }, { field: 'contact', title: 'Company', width: '250' }];
                this.reorderColumnName = 'tag,contact';
                this.columnWidth = 'tag:800,contact:250';
                this.arrColumnWidth = ['tag:800,contact:250'];
                break;
        }
        //this.resetGridSetting()

    }

    setGrid(list) {
        if (this.roleFeaturePermissions?.edit && this.roleFeaturePermissions.delete) {
            this.columns.push({ field: 'action', title: 'Action', width: '250' })
        }
        this.tagSettingsDataDisplayColumns = this.columns.map(c => c.field);

        this.tagSettingsDataSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.tagSettingsDataSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('tag_setting_grid') ? this._localService.getPageSize('tag_setting_grid'): 50;
            }
            if (this.sort) {
                this.tagSettingsDataSource.sort = this.sort;
                const sortState: Sort = this._localService.getSortState('tag_setting_grid');
                this.sort.active = sortState?.active;
                this.sort.direction = sortState?.direction;
                this.sort.sortChange.emit(sortState);
            }
        }, 500)

    }

    getSerialNumber(index: number): number {
        return index + 1 + (this.paginator?.pageIndex || 0) * (this.paginator?.pageSize || 5);
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

    ngOnDestroy() {
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }
}
